module.exports = __webpack_public_path__ + "img/trans_type.c3c5830f.svg";